<template>

    <DialogueBox :blur="true" :height="638" :width="731" :top="97" :left="297">

        <div class="vote-result-box">
            <div class="vote-result-header" v-html="headerText"></div>
            <div class="text" v-html="text"></div>
            <div class="divider"></div>
            <div class="yes">YES</div>
            <div class="no">NO</div>
            <div class="yes-votes" v-html="yesVotes"></div>
            <div class="no-votes" v-html="noVotes"></div>
            <div class="confirm-button" v-html="T('button_continue')" @click="$emit('dismissed-vote-results')"></div>
        </div>

        <div class="facilitator"></div>
        <div class="facilitator-tick"> </div>

    </DialogueBox>
</template>
<script lang="ts">
import { T } from '@/App.vue';
import Vue from 'vue';
import DialogueBox from "./DialogueBox.vue";

export default Vue.extend({
    name: 'DialogueBoxVoteResult',
    components: {
        DialogueBox
    },
    props: {
        yesVotes: Number,
        noVotes: Number,
        isNatureBased: Boolean,
        natureBasedVoteType: Boolean,
        stopBankVoteType: Number,
    },
    computed: {
        headerText:
        {
            cache: false,
            get(): string {
                if (this.isNatureBased) {
                    if (this.natureBasedVoteType) {
                        return T('Build_naturebased_sea_poll_results');
                    }
                    return T('Build_naturebased_poll_results');
                }

                switch (this.stopBankVoteType) {
                    case 2:
                        return T('Build_seawall_poll_results_2');

                    case 1:
                        return T('Build_seawall_poll_results_1');

                    default:
                        return T('Build_stopbank_poll_results');
                }
            }
        },
        text:
        {
            cache: false,
            get(): string {

                /*
                let result = "";

                if (this.isNatureBased) {
                    result = 'build_naturebased_results_text';
                }
                else {
                    result = 'build_stopbank_results_text';
                }

                if (this.noVotes == 0) {
                    //Success
                    result += "_yes";
                }
                else {
                    result += "_no";
                }
                    */

                return "";// T(result);
            }
        }
    },
    methods: {
        T(key: string): string {
            return T(key);
        }
    }
});
</script>

<style scoped lang="less">
.facilitator {
    width: 270px;
    height: 344.54px;
    top: 247.38px;
    left: -198px;
    position: absolute;
    z-index: -1;
}

.facilitator-tick {
    top: 257px;
    left: -33px;
    rotate: -90deg;
}

.vote-result-box {
    padding-top: 113px;
    padding-left: 60px;
    padding-right: 60px;
    color: #636252;
    position: relative;
}

.vote-result-header {
    font-family: Rubik;
    font-size: 30px;
    font-weight: 800;
    line-height: 35.55px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
}

.text {
    margin-top: 22px;
    font-family: Rubik;
    font-size: 16px;
    font-weight: 400;
    line-height: 18.96px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

}

.divider {
    box-sizing: border-box;
    height: 128px;
    width: 1px;
    border: 2px solid #333333;
    position: absolute;
    top: 299.5px;
    left: 181.5px;
}

.yes {
    font-family: Rubik;
    font-size: 24px;
    font-weight: 700;
    line-height: 28.44px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    position: absolute;
    top: 299px;
    width: 52px;
}

.no {
    .yes;
    left: 252px;
}

.yes-votes {
    font-family: Rubik;
    font-size: 80px;
    font-weight: 700;
    line-height: 94.8px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #B2CD30;
    position: absolute;
    top: 325px;
    width: 52px;
}

.no-votes {
    .yes-votes;
    color: #F1A738;
    left: 252px;
}

.confirm-button {
    width: 162px;
    height: 50px;
    top: 475px;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    font-family: Rubik;
    font-size: 14px;
    font-weight: 800;
    line-height: 16.59px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: white;
}
</style>
